


































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import Datatable from '@/components/Datatable.vue';
import MetaDatatable from '../../models/MetaDatatable';
import HeaderDatatable from '../../models/HeaderDatatable';
import cloneDeep from 'lodash/cloneDeep';
import { getAllLotsPrescriber, postLotsArchivePrescriber } from "@/api/api";
import SideBarPrescriber from "@/components/prescriber/SideBarPrescriber.vue";
import FiltersModule from "@/store/FiltersModule";
import AuthModule from "@/store/AuthModule";
import ListModule from "@/store/ListModule";
import moment from "moment";
import { forEach } from "lodash";
import Program from "@/models/Program";
import animateCSS from "@/utils/animateCSS";
import Lot from "@/models/Lot";
import DenouncePopup from '@/components/prescriber/DenouncePopup.vue';
import { saveAs } from 'file-saver';
import transformFilters from '@/utils/transformFilters';
import FilterModule from '@/store/FiltersModule';
import getOptionInfos from '../../utils/notifications';
import BRSModal from '@/components/prescriber/BRSModal.vue';
import {isBrs} from '@/utils/isBrs'

import { BACKEND_URL } from '@/helpers/constants';


@Component({
  filters: {

    conditionalRentLimitPkAlone(value: any, record: any) {
      // Vérifier si le lot a de la "Revente LMNP"
      const hasReventeLMNP = Array.isArray(record.program.tax_system) &&
        record.program.tax_system.some((ts: string) => ts.startsWith('Revente LMNP'));
      
      // Si c'est de la Revente LMNP, retourner vide, sinon afficher la valeur
      return hasReventeLMNP ? '' : (value ? value + ' €' : '');
    },
    
    conditionalTotalTVA(record: any) {
      const hasReventeLMNP = Array.isArray(record.program.tax_system) &&
        record.program.tax_system.some((ts: string) => ts.startsWith('Revente LMNP'));
      
      if (hasReventeLMNP) return '';
      
      // Logique existante pour Prix total TVA
      if (record.price > 0 && record.location_amount_furniture > 0) {
        return record.price - record.location_amount_furniture + ' €';
      }
      return '';
    },
    
    conditionalRecommendedRent(value: any, record: any) {
      const hasReventeLMNP = Array.isArray(record.program.tax_system) &&
        record.program.tax_system.some((ts: string) => ts.startsWith('Revente LMNP'));
      
      return hasReventeLMNP ? '' : (value ? value + ' €' : '');
    },

    honoHT(lot: any) {
      if (lot.program.duty_free_fee) {
        let price = (lot.program.duty_free_fee / 100) * lot.price;

        // Si les honoraires calculés sont > 0, on affiche la valeur, sinon 'NC'
        return price > 0 ? '~' + Math.round(price) + ' €' : 'NC';
      } else {
        return 'NC';  
      }
    },

    displayDutyFreeFee(program: any, component: any) {
      const base = Number(program.duty_free_fee) || 0;

        if (base > 0) {
          return component.getDisplayDutyFreeFee(program);  // Retourne la valeur formatée
        } else {
          return 'NC';  
        }
    },


    coteWork(lot: any) {
      if (lot.amount_work > 0) {
        let value: number = (lot.amount_work / (lot.amount_property + lot.amount_work)) * 100
        return '~' + Math.round(value) + ' %'
      } else {
        return;
      }
    },
    priceM(lot: any) {
      if (lot.price > 0 && lot.surface_carrez > 0) {
        let price = lot.price / lot.surface_carrez;
        return '~' + Math.round(price) + ' €'
      } else {
        return "/"
      }
    },
    totalTVAFilter(lot: any) {
      if (lot.price > 0 && lot.location_amount_furniture > 0) {
        return lot.price - lot.location_amount_furniture;
      } else {
        return;
      }
      return;
    },
    formatDate(lot: any) {
      return moment(lot.updated_at).format('L');
    },
    tva_recup: function (lot: any) {
      if (lot.price > 0 && lot.location_amount_property > 0) {
        return (lot.price - lot.location_amount_property) + '€'
      } else {
        return;
      }
    },
    euro: function (value: number) {
      return (value != null) ? new Intl.NumberFormat('fr-FR', {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 0,
      }).format(value) : '';
    },
    twoDigits: function (value: number) {
      return Math.round(value * 100) / 100
    },
    formatProfitability: (lot: any) => {
      if (!isNaN(lot.rent_limit_pinel)) {
        let rent = ((lot.rent_limit_pinel * 12) / lot.price) * 100;
        return "~" + new Intl.NumberFormat('fr-FR', {
          maximumFractionDigits: 1,
        }).format(rent) + "%";
      }

      if (isNaN(lot.profitability)) {
        return '';
      }

      return "~" + new Intl.NumberFormat('fr-FR', {
        maximumFractionDigits: 1,
      }).format(lot.profitability) + "%";
    },
    surfaceFilter(surface: number) {
      if (surface == undefined || surface == 0) {
        return;
      } else {
        return surface + " m²";
      }
    },
    priceFilter(price: number) {
      return (price != null) ? new Intl.NumberFormat('fr-FR', {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 0,
      }).format(price) : '';
    },
    typeFilter(type: string) {
      let typeResponse: string;
      switch (type) {
        case 'studio': typeResponse = "Studio"; break;
        case 'flat': typeResponse = "Appartement"; break;
        case 'pro_local': typeResponse = "Local pro"; break;
        case 'house': typeResponse = "Maison"; break;
        case 'duplex_house': typeResponse = "Maison Duplex"; break;
        case 'building': typeResponse = "Immeuble"; break;
        case 'land_house': typeResponse = "Terrain et Maison"; break;
        case 'duplex_apartment': typeResponse = "Appartement Duplex"; break;
        case 'box': typeResponse = "Box"; break;
        default: typeResponse = "other"; break;
      }
      return typeResponse;
    },

    dateDelivery(program: any) {
        if (program && program.date_delivery) {
          return moment(program.date_delivery).format('L');
        }
        return '-';
      },

      
    status(type: string) {
      let typeResponse: string;
      switch (type) {
        case 'retired': typeResponse = "Retiré de la vente"; break;
        case 'acted': typeResponse = "Acté"; break;
        case 'booked': typeResponse = "Réservé"; break;
        case 'optionned': typeResponse = "Optionné"; break;
        case 'available': typeResponse = "Libre"; break;
        default: typeResponse = "nc"; break;
      }
      return typeResponse;
    },
  },
  components: {
    Datatable,
    DenouncePopup,
    SideBarPrescriber,
    BRSModal
  },
})
export default class LotDetail extends Vue {
  giveUrlPlan(lot: any) {
    if (lot.plan != undefined) {
      let fullUrl = 'https://api.plugimmo.pro' + lot.plan.url + lot.plan.file_name + "." + lot.plan.extension
      return '<a href="' + fullUrl + '" target="_blank"><img src=\"https://www.anco.pro/wp-content/uploads/2012/12/plan-architecte-moyen.jpg\" alt=\"\" style=\"width: 60px;height: 60px\"></a>'
    } else {
      return "/";
    }
  }
  giveLinkPrg(lot: any) {
    return '<a href="\\details\\' + lot.program.id + '" target="_blank">' + lot.program.name + '</a>'
  }
  tutoPopup: Boolean = false;
  popupDenounce: Boolean = false;
  showConfirm: Boolean = false;
  showManuel: Boolean = false;
  brsOpen: boolean = false;


  get getOptionInfos() {
    return getOptionInfos;
  }

  get isRestricted() {
    return AuthModule.isRestricted
  }

  async saveExport() {
    if (this.lotsSelected.length === 0) {
      this.tutoPopup = true;
      return false;
    }
    this.lotsSelected.forEach(lot => {
      /*
      if (
          lot.program.id_import == '' ||
          lot.program.id_import === null ||
          typeof lot.program.id_import == 'undefined'
      ) {
        this.showManuel = true;
      }
      */
    });
    this.showConfirm = true;
  }

  async accept() {
    this.showManuel = false;
    this.showConfirm = false;
    this.downloadLots();
  }



   // ← New fields for Hono
   withHono: boolean = false;
  commissionRate: number = 0;

  // ... existing code ...

        created() {
          this.loadCommissionRateFromAuth();
        }

         loadCommissionRateFromAuth() {
          const raw = localStorage.getItem('auth');
          if (!raw) return;
          
          try {
            const auth = JSON.parse(raw);
            const subs = Array.isArray(auth.subscriptions) ? auth.subscriptions : [];
            if (!subs.length) return;
            
            const last = subs[subs.length - 1];
            console.log(
              '[Auth] last.with_hono =', last.with_hono,
              ', last.commission_rate =', last.commission_rate
            );
            
            this.withHono = !!last.with_hono;
            this.commissionRate = typeof last.commission_rate === 'string'
              ? parseFloat(last.commission_rate)
              : Number(last.commission_rate) || 0;
              
            console.log(
              '[Auth] this.withHono =', this.withHono,
              ', this.commissionRate =', this.commissionRate
            );
          } catch (e) {
            console.error('[Auth] JSON.parse error:', e);
          }
        }

        // Method to calculate the display duty free fee
            getDisplayDutyFreeFee(program: any): string {
              const base = Number(program.duty_free_fee) || 0;
              
              // Si la base est inférieure à 0, on retourne 'NC'
              if (base < 0) {
                return 'NC';
              }

              if (this.withHono && this.commissionRate > 0) {
                const diff = Math.round((base - this.commissionRate) * 100) / 100;
                // Si diff est inférieur à 0, on retourne 'NC'
                if (diff < 0) {
                  return 'NC';
                }
                return `${diff}%`;
              }
              
              return `${base}%`;
            }


        // Method to calculate the actual fee percentage for calculations
        getActualDutyFreeFeeRate(program: any): number {
          const base = Number(program.duty_free_fee) || 0;
          if (this.withHono && this.commissionRate > 0) {
            return Math.max(0, base - this.commissionRate);
          }
          return base;
        }


        calculateHonoAmount(lot: any): string {
              if (lot.program.duty_free_fee) {
                // Get the actual fee rate (after commission adjustment)
                const actualRate = this.getActualDutyFreeFeeRate(lot.program);
                if (actualRate <= 0) {
                  return '';
                }
                let price = (actualRate / 100) * lot.price;
                return '~' + Math.round(price) + ' €';
              } else {
                return '';
              }
            }
        


  /*
    async saveCompare() {
      return false;
    }
    */

  async saveDenounce() {
    if (this.lotsSelected.length === 0) {
      this.tutoPopup = true;
      return false;
    }
    this.popupDenounce = true
  }

  brs(lot: Lot, program: Program) {
    return isBrs(lot, program)
  }

  async downloadLots() {
    const $vs = (this as any).$vs;
    $vs.loading({
      type: 'corners',
      text: "L'outil PlugIMMO est en train de créer votre dossier commercial correspondant à la recherche de votre client, veuillez patienter car cela peut prendre jusqu'à 2 min"
    })
    let filename = `Documents des lots.zip`;
    postLotsArchivePrescriber({
      lots: ListModule.lotsSelected.map(lot => lot.id || -1),
    })
      .then(({ data }) => {
        saveAs(data, filename);
        $vs.loading.close()
      })
      .catch(async error => {
        const $vs = (this as any).$vs;
        $vs.notify({
          color: 'danger',
          position: 'top-right',
          title: 'Erreur',
          text: JSON.parse(await error.response.data.text()).message,
        });
        $vs.loading.close()

        if (error.response.status === 403) {
          location.reload();
        }
      });
  }

  mounted() {
    ListModule.fetch();
  }

  addSelected(lot: any) {
    var lots = this.lotsSelected;
    var position = lots.indexOf(lot);
    if (position > -1) {
      lots.splice(position, 1);
    } else {
      lots.push(lot);
    }
    ListModule.setLotsSelected(lots)
  }


  get firstname() {
        return AuthModule.firstname;
    }


    get lastname() {
        return AuthModule.lastname;
    }

    get logo() {
        return AuthModule.logo;
    }

    get isSubscribed() {
        return AuthModule.isSubscriptionActive;
    }

    get isTrial() {
        return AuthModule.isTrialActive;
    }

    get backendUrl() {
        return BACKEND_URL;
    }



  get lotsSelected() {
    return ListModule.lotsSelected;
  }

  selectedLot: Lot[] = [];
  defaultMeta: MetaDatatable = {
    total: 0,
    pages: 0,
    page: 1,
    perPage: 20,
    search: null,
    orderBy: "updated_at",
    orderWay: "DESC",
    filters: null,
    exclusions: {
      role: 'ROLE_ANONYMOUS',
    },
  };
  filters: any = FiltersModule.filters;
  @Watch('filters', { deep: true })
  onFilters() {
    this.meta.filters = this.filters;
  }
  meta: MetaDatatable = cloneDeep(this.defaultMeta);
  columns: HeaderDatatable[] = [];

  reset(): void {
    this.filters = {
      status: '',
      dateInterval: [0, 98],
      budget: {
        min: null,
        max: null,
      },
      program: null,
      taxes: [],
      types: [],
      types2: [],
      outdoors: [],
      region: undefined,
      departement: undefined,
      city: undefined,
      country: undefined,  
      timeStep: 5,
      dutyFreeFeeMin: 0,
      profitabilityProgramGtieInterval: [1, 15],
      profitabilityProgramGtieStep: 1,
      promotor: undefined,
      type_flux: null,
      zones: [],
      statusProgram: AuthModule.roles.includes("ROLE_MANAGER") ? ["to_control", "data_processing", "diffused"] : ['diffused'],
      electronic_sign: null,
      commercials: null
    };
    // ListModule.setLotsSelected([]);
    // localStorage.removeItem('customerIDDenouncedFresh')
  }

  async fetch(meta: MetaDatatable) {
    let fieldName = meta.orderBy;
    const saveSelect = this.selectedLot

    // conversion entre champs reçu et champs attendu en base de données
    switch (meta.orderBy) {
      // lot
      case null: fieldName = "l.price"; break;
      case 'surface_carrez': fieldName = "l.surfaceCarrez"; break;
      case 'surface_no_carrez': fieldName = "l.surfaceNoCarrez"; break;
      case 'surface_terrace': fieldName = "l.surfaceTerrace"; break;
      case 'price_parking': fieldName = "l.priceParking"; break;
      case 'name_parking1': fieldName = "l.nameParking1"; break;
      case 'cat_parking_1': fieldName = "l.catParking1"; break;
      case 'name_parking2': fieldName = "l.nameParking2"; break;
      case 'cat_parking_2': fieldName = "l.catParking2"; break;
      case 'name_parking3': fieldName = "l.nameParking3"; break;
      case 'cat_parking_3': fieldName = "l.catParking3"; break;
      case 'rent_limit_lgt_alone': fieldName = "l.rentLimitLgtAlone"; break;
      case 'rent_limit_pk_alone': fieldName = "l.rentLimitPkAlone"; break;
      case 'surface_copro_garden': fieldName = "l.surfaceCoproGarden"; break;
      case 'rent_limit_pinel': fieldName = "l.rentLimitPinel"; break;
      case 'location_amount_property': fieldName = "l.locationAmountProperty"; break;
      case 'location_amount_furniture': fieldName = "l.locationAmountFurniture"; break;
      case 'amount_property': fieldName = "l.amountProperty"; break;
      case 'amount_work': fieldName = "l.amountWork"; break;
      case 'rent_limit_market': fieldName = "l.rentLimitMarket"; break;
      case 'duty_free_fee': fieldName = "l.dutyFreeFee"; break;
      case 'updated_at': fieldName = "l.updatedAt"; break;
      case 'created_at': fieldName = "l.createdAt"; break;
      case 'maximum_monthly_market_rent': fieldName = "l.maximumMonthlyMarketRent"; break;
      case 'selling_fee': fieldName = "l.sellingFee"; break;
      case 'amount_work_no_defisc': fieldName = "l.amountWorkNoDefisc"; break;
      // case 'price_vat_reduce_or_controlled' : fieldName = "l.priceVatReduceOrControlled"; break;
      case 'garantee_rent': fieldName = "l.garanteeRent"; break;
      case 'recommended_market_rent_pk_included': fieldName = "l.recommendedMarketRentPkIncluded"; break;
      case 'full_ownership_amount': fieldName = "l.fullOwnershipAmount"; break;
      // program
      case 'program.name': fieldName = "p.name"; break;
      case 'program.date_delivery': fieldName = "p.dateDelivery"; break;
      case 'program.address.city': fieldName = "a.city"; break;
      case 'program.address.postal_code': fieldName = "a.postal_code"; break;
      case 'program.duty_free_fee': fieldName = "p.dutyFreeFee"; break;
      default: fieldName = "l." + fieldName; break;
    }
    if (meta.page < 1) {
      meta.page = 1;
    }
    const filters = transformFilters(FilterModule.filters);
    //@ts-ignore
    const { data } = await getAllLotsPrescriber(meta.perPage, meta.orderWay, fieldName, filters, meta.page - 1);
    const hasNormalLmnpColumn = (data.data as any[]).some((lot: any) =>
      Array.isArray(lot.program.tax_system) &&
      (lot.program.tax_system as string[]).some((ts: string) =>
        ts.includes('LMNP') && !ts.startsWith('Revente LMNP')
      )
    );
    const hasLMNPRevente = (data.data as any[]).some((lot: any) =>
      Array.isArray(lot.program.tax_system) &&
      (lot.program.tax_system as string[]).some((ts: string) =>
        ts.startsWith('Revente LMNP')
      )
    );

    
    this.counter = {
      building: 0,
      exposure: 0,
      surface_no_carrez: 0,
      surface_terrace: 0,
      surface_terrace_varangue: 0,
      surface_copro_garden: 0,
      rent_limit_pinel: 0,
      rent_limit_lgt_alone: 0,
      rent_limit_pk_alone: 0,
      amount_property: 0,
      profitability: 0,
      location_amount_property: 0,
      location_amount_furniture: 0,
      prix_nue_propriete: 0,
      price_vat_reduce_or_controlled: 0,
      price_reduced_brs: 0,
      price_reduced_lli: 0,
      full_ownership_amount: 0,
      selling_fee: 0,
      maximum_monthly_market_rent: 0,
      rent_limit_market: 0,
      garantee_rent: 0,
      recommended_market_rent_pk_included: 0,
      price_parking: 0,
      name_parking1: 0,
      cat_parking1: 0,
      name_parking2: 0,
      cat_parking2: 0,
      name_parking3: 0,
      cat_parking3: 0,
      duty_free_fee: 0,
      amount_work: 0,
      surface_land: 0,
      amount_work_no_defisc: 0,
    }

    //check si au moins une colonne possede une propriété
    for (const value of data.data) {
      if (value['building'] != undefined) { this.counter.building++ }
      if (value['exposure'] != undefined) { this.counter.exposure++ }
      if (value['surface_no_carrez'] != undefined) { this.counter.surface_no_carrez++ }
      if (value['surface_terrace'] != undefined) { this.counter.surface_terrace++ }
      if (value['surface_terrace_varangue'] != undefined) { this.counter.surface_terrace_varangue++ }
      if (value['surface_copro_garden'] != undefined) { this.counter.surface_copro_garden++ }
      if (value['rent_limit_pinel'] != undefined) { this.counter.rent_limit_pinel++ }
      if (value['rent_limit_lgt_alone'] != undefined) { this.counter.rent_limit_lgt_alone++ }
      if (value['rent_limit_pk_alone'] != undefined) { this.counter.rent_limit_pk_alone++ }
      if (value['amount_property'] != undefined) { this.counter.amount_property++ }
      if (value['profitability'] != undefined) { this.counter.profitability++ }
      if (value['location_amount_property'] != undefined) { this.counter.location_amount_property++ }
      if (value['location_amount_furniture'] != undefined) { this.counter.location_amount_furniture++ }
      if (value['prix_nue_propriete'] != undefined && value['prix_nue_propriete'] > 0) {this.counter.prix_nue_propriete++;}
      if (value['price_vat_reduce_or_controlled'] != undefined) { this.counter.price_vat_reduce_or_controlled++ }
      if (value['price_reduced_brs'] != undefined) { this.counter.price_reduced_brs++ }
      if (value['price_reduced_lli'] != undefined) { this.counter.price_reduced_lli++ }
      if (value['full_ownership_amount'] != undefined) { this.counter.full_ownership_amount++ }
      if (value['selling_fee'] != undefined) { this.counter.selling_fee++ }
      if (value['maximum_monthly_market_rent'] != undefined) { this.counter.maximum_monthly_market_rent++ }
      if (value['rent_limit_market'] != undefined) { this.counter.rent_limit_market++ }
      if (value['garantee_rent'] != undefined) { this.counter.garantee_rent++ }
      if (value['recommended_market_rent_pk_included'] != undefined) { this.counter.recommended_market_rent_pk_included++ }
      if (value['price_parking'] != undefined) { this.counter.price_parking++ }
      if (value['name_parking1'] != undefined) { this.counter.name_parking1++ }
      if (value['cat_parking1'] != undefined) { this.counter.cat_parking1++ }
      if (value['name_parking2'] != undefined) { this.counter.name_parking2++ }
      if (value['cat_parking2'] != undefined) { this.counter.cat_parking2++ }
      if (value['name_parking3'] != undefined) { this.counter.name_parking3++ }
      if (value['cat_parking3'] != undefined) { this.counter.cat_parking3++ }
      if (value['amount_work'] != undefined) { this.counter.amount_work++ }
      if (value['surface_land'] != undefined) { this.counter.surface_land++ }
      if (value['amount_work_no_defisc'] != undefined) { this.counter.amount_work_no_defisc++ }
      if (value['program']['duty_free_fee'] != undefined) { this.counter.duty_free_fee++ }
    }

    // Ajout des colonnes de base au tableaux
    this.columns = [
      {
        title: 'Selection',
        dataIndex: 'select',
        scopedSlots: {
          customRender: 'selectLot',
        },
      },
      {
        title: 'Plan',
        dataIndex: 'id',
        scopedSlots: {
          customRender: 'plan',
        },
      },
      {
        title: 'Nom Programme',
        dataIndex: 'program.name',
        scopedSlots: {
          customRender: 'linkPrg',
        },
        sorter: true,
      },
      {
        title: 'Statut',
        dataIndex: 'status',
        scopedSlots: {
          customRender: 'status',
        },
        sorter: true,
      },
      {
        title: 'Date changement dernier Statut',
        dataIndex: 'updated_at',
        scopedSlots: {
          customRender: 'date',
        },
        sorter: true,
      },


      {
        title: 'Date livraison',
        dataIndex: 'program.date_delivery',
        scopedSlots: {
          customRender: 'dateDelivery',
        },
        sorter: true,
      },


      // {
      //   title: 'Date livraison',
      //   dataIndex: 'program.date_delivery',
      //   scopedSlots: {
      //     customRender: 'date',
      //   },
      //   // sorter: true,
      // },
      {
        title: 'Promoteur',
        dataIndex: 'program.promoter.name',
        // sorter: true,
      },
      {
        title: 'Ville',
        dataIndex: 'program.address.city',
        sorter: true,
      },
      {
        title: 'Code postal',
        dataIndex: 'program.address.postal_code',
        sorter: true,
      },
      {
        title: 'Adresse',
        dataIndex: 'program.address.street',
        // sorter: true,
      },
      {
        title: 'N° de Lot',
        dataIndex: 'name',
        sorter: true,
      },
      {
        title: 'Type',
        dataIndex: 'type',
        scopedSlots: {
          customRender: 'type',
        },
        sorter: true,
      },
      {
        title: 'Nb pièce(s)',
        dataIndex: 'type2',
        sorter: true,
      },
      {
        title: 'Etage',
        dataIndex: 'floor',
        sorter: true,
      },
      {
        title: 'Sdp',
        dataIndex: 'surface_carrez',
        scopedSlots: {
          customRender: 'surface',
        },
        sorter: true,
      },
      {
        title: 'Prix/m²',
        dataIndex: 'random',
        scopedSlots: {
          customRender: 'priceM',
        },
      },
      {
        title: 'Prix Total TTC',
        dataIndex: 'price',
        scopedSlots: {
          customRender: 'price',
        },
        sorter: true,
      },
    ];

    if (true) { // Change to condition if needed
      this.columns.splice(1, 0, {
        title: 'Fiscalité',
        dataIndex: 'program.tax_system',
        scopedSlots: {
          customRender: 'tax_system',
        },
      });
    }

    // Si au moins un lot a un prix en nue-propriété, on ajoute les colonnes
      if (this.counter.prix_nue_propriete > 0) {
        this.columns.push(
          {
            title: 'Prix Pleine Propriété',
            dataIndex: 'price', // Réutilise la valeur de 'Prix Total TTC'
            scopedSlots: {
              customRender: 'euro', // Affichage en euros
            },
            sorter: true,
          },
          {
            title: 'Prix Nue-Propriété',
            dataIndex: 'prix_nue_propriete',
            scopedSlots: {
              customRender: 'euro', // Utilise le filtre pour afficher correctement le prix en euros
            },
            sorter: true,
          },
        );
      }

        if (this.counter.price_vat_reduce_or_controlled > 0) {
      this.columns.push({
        title: 'Prix total TVA 5,5%/Prix maitrisé',
        dataIndex: 'price_vat_reduce_or_controlled',
        scopedSlots: {
          customRender: 'euro',
        }
      });
    }

    if (this.counter.price_reduced_lli > 0) {
      this.columns.push({
        title: 'Prix LLI (Tva 10%)',
        dataIndex: 'price_reduced_lli',
        scopedSlots: {
          customRender: 'euro',
        }
      });
    }

    if (this.counter.price_reduced_brs > 0) {
      this.columns.push({
        title: 'Prix BRS (Tva 5.5%)',
        dataIndex: 'price_reduced_brs',
        scopedSlots: {
          customRender: 'euro',
        }
      });
    }

    if (this.counter.location_amount_property > 0 && hasNormalLmnpColumn) {
      this.columns.push({
        title: 'LMNP total HT',
        dataIndex: 'location_amount_property',
        scopedSlots: {
          customRender: 'euro',
        },
        sorter: true
      });
    }

    // ajout des colonnes si données existante
    if (this.counter.building > 0) {
      this.columns.push({
        title: 'Batiment',
        dataIndex: 'building',
        sorter: true,
      },)
    }
    if (this.counter.exposure > 0) {
      this.columns.push({
        title: 'Expo',
        dataIndex: 'exposure',
        sorter: true,
      },)
    }
    if (this.counter.surface_no_carrez > 0) {
      this.columns.push({
        title: 'Surface < 1.8m',
        dataIndex: 'surface_no_carrez',
        scopedSlots: {
          customRender: 'surface',
        },
        sorter: true,
      },)
    }
    if (this.counter.surface_terrace > 0) {
      this.columns.push(
        {
          title: 'm² Terrasse loggia',
          dataIndex: 'surface_terrace',
          scopedSlots: {
            customRender: 'surface',
          },
          sorter: true,
        }
        ,)
    }
    if (this.counter.surface_land > 0) {
      this.columns.push(
        {
          title: 'm² Terrain',
          dataIndex: 'surface_land',
          scopedSlots: {
            customRender: 'surface',
          },
          sorter: true,
        }
        ,)
    }
    if (this.counter.surface_terrace_varangue > 0) {
      this.columns.push({
        title: 'm² Terrasse varangue',
        dataIndex: 'surface_terrace_varangue',
        scopedSlots: {
          customRender: 'surface',
        },
        sorter: true,
      },)
    }
    if (this.counter.surface_copro_garden > 0) {
      this.columns.push({
        title: 'm² Jardin',
        dataIndex: 'surface_copro_garden',
        scopedSlots: {
          customRender: 'surface',
        },
        sorter: true,
      },)
    }
    if (this.counter.rent_limit_pinel > 0) {
      this.columns.push(
        {
          title: 'Plafond Loyer',
          dataIndex: 'rent_limit_pinel',
          scopedSlots: {
            customRender: 'euro',
          },
          sorter: true,
        },
      )
    }
    if (this.counter.rent_limit_lgt_alone > 0) {
      this.columns.push(
        {
          title: 'Plafond Loyer LGT seul',
          dataIndex: 'rent_limit_lgt_alone',
          scopedSlots: {
            customRender: 'euro',
          },
          sorter: true,
        },
      )
    }
    if (this.counter.rent_limit_pk_alone > 0) {
      this.columns.push(
        {
          title: 'Plafond Loyer PK seul',
          dataIndex: 'rent_limit_pk_alone',
          scopedSlots: {
            customRender: 'conditionalRentLimitPkAlone',
          },
          sorter: true,
        },
      )
    }
    if (this.counter.profitability > 0) {
      this.columns.push(
        {
          title: 'Renta. Gtie/renta calculée',
          dataIndex: 'profitability',
          scopedSlots: {
            customRender: 'profitability',
          },
          sorter: true,
        },
      )
    }
    if (this.counter.location_amount_furniture > 0 && hasNormalLmnpColumn) {
      this.columns.push(
        {
          title: 'LMNP dont montant mobilier HT',
          dataIndex: 'location_amount_furniture',
          scopedSlots: {
            customRender: 'euro',
          },
          sorter: true,
        },
      )
    }
    if (this.counter.location_amount_furniture > 0) {
      this.columns.push(
        {
          title: 'Prix total TVA',
          dataIndex: 'totaltva',
          scopedSlots: {
            customRender: 'conditionalTotalTVA',
          },
        },
      )
    }
    if (this.counter.full_ownership_amount > 0) {
      this.columns.push(
        {
          title: 'Montant Nu propriété',
          dataIndex: 'full_ownership_amount',
          scopedSlots: {
            customRender: 'euro',
          },
          sorter: true,
        },
      )
    }
    if (this.counter.maximum_monthly_market_rent > 0) {
      this.columns.push(
        {
          title: 'Loyer marché mensuel maxi ',
          dataIndex: 'maximum_monthly_market_rent',
          scopedSlots: {
            customRender: 'euro',
          },
          sorter: true,
        },
      )
    }
    if (this.counter.rent_limit_market > 0) {
      this.columns.push(
        {
          title: 'Loyer marché mensuel maxi',
          dataIndex: 'rent_limit_market',
          scopedSlots: {
            customRender: 'euro',
          },
          sorter: true,
        },
      )
    }
    if (this.counter.garantee_rent > 0) {
      this.columns.push(
        {
          title: 'Montant loyer mensuel TTC hors charges pour revente LMNP/LMP',
          dataIndex: 'garantee_rent',
          scopedSlots: {
            customRender: 'euro',
          },
          sorter: true,
        },
      )
    }
    if (this.counter.recommended_market_rent_pk_included > 0 && false) {
      this.columns.push(
        {
          title: 'Loyer Marché recommandé Pk inclus',
          dataIndex: 'recommended_market_rent_pk_included',
          scopedSlots: {
            customRender: 'conditionalRecommendedRent',
          },
          sorter: true,
        },
      )
    }
    if (this.counter.price_parking > 0) {
      this.columns.push(
        {
          title: 'Dont prix total TTC tous les Pk',
          dataIndex: 'price_parking',
          scopedSlots: {
            customRender: 'euro',
          },
          sorter: true,
        },
      )
    }
    if (this.counter.name_parking1 > 0) {
      this.columns.push(
        {
          title: 'Stationnement N°1',
          dataIndex: 'name_parking1',
          sorter: true,
        },
      )
    }
    if (this.counter.cat_parking1 > 0) {
      this.columns.push(
        {
          title: 'Cat. Stationnement N°1',
          dataIndex: 'cat_parking1',
          // sorter: true,
        },
      )
    }
    if (this.counter.name_parking2 > 0) {
      this.columns.push(
        {
          title: 'Stationnement N°2',
          dataIndex: 'name_parking2',
          sorter: true,
        },
      )
    }
    if (this.counter.cat_parking2 > 0) {
      this.columns.push(
        {
          title: 'Cat. Stationnement N°2',
          dataIndex: 'cat_parking2',
          // sorter: true,
        },
      )
    }
    if (this.counter.name_parking3 > 0) {
      this.columns.push(
        {
          title: 'Stationnement N°3',
          dataIndex: 'name_parking3',
          sorter: true,
        },
      )
    }
    if (this.counter.cat_parking3 > 0) {
      this.columns.push(
        {
          title: 'Cat. Stationnement N°3',
          dataIndex: 'cat_parking3',
          // sorter: true,
        },
      )
    }


 
      // Check if there are any lots with actual duty_free_fee > 0 after commission adjustment
          const hasValidDutyFreeFee = (data.data as any[]).some((lot: any) => {
            const actualRate = this.getActualDutyFreeFeeRate(lot.program);
            return actualRate > 0;
          });

          if (hasValidDutyFreeFee) {
            this.columns.push(
              {
                title: 'Tx hono HT/TTC',
                dataIndex: 'program',
                scopedSlots: {
                  customRender: 'displayDutyFreeFee',
                },
              },
            )
          }

          if (hasValidDutyFreeFee) {
            this.columns.push(
              {
                title: 'Montant Hono. HT/TTC',
                dataIndex: 'random3',
                scopedSlots: {
                  customRender: 'honoHT',
                },
              },
            )
          }






    if (this.counter.amount_work_no_defisc > 0) {
      this.columns.push(
        {
          title: 'Montant travaux hors defisc. (parties communes)',
          dataIndex: 'amount_work_no_defisc',
          scopedSlots: {
            customRender: 'euro',
          },
        },
      )
    }
    if (this.counter.amount_property > 0) {
      this.columns.push(
        {
          title: 'Montant foncier hors travaux',
          dataIndex: 'amount_property',
          scopedSlots: {
            customRender: 'euro',
          },
          sorter: true,
        },
      )
    }
    if (this.counter.amount_work > 0) {
      this.columns.push(
        {
          title: 'Cote part travaux',
          dataIndex: 'random2',
          scopedSlots: {
            customRender: 'coteWork',
          },
        },
      )
    }
    if (this.counter.amount_work > 0) {
      this.columns.push(
        {
          title: 'Montant travaux hors foncier',
          dataIndex: 'amount_work',
          scopedSlots: {
            customRender: 'euro',
          },
        },
      )
    }
    this.selectedLot = saveSelect
    return data;
  }

  counter = {
    building: 0,
    exposure: 0,
    surface_no_carrez: 0,
    surface_terrace: 0,
    surface_terrace_varangue: 0,
    surface_copro_garden: 0,
    rent_limit_pinel: 0,
    rent_limit_lgt_alone: 0,
    rent_limit_pk_alone: 0,
    amount_property: 0,
    profitability: 0,
    location_amount_property: 0,
    location_amount_furniture: 0,
    price_vat_reduce_or_controlled: 0,
    prix_nue_propriete: 0,
    price_reduced_brs: 0,
    price_reduced_lli: 0,
    full_ownership_amount: 0,
    selling_fee: 0,
    maximum_monthly_market_rent: 0,
    rent_limit_market: 0,
    garantee_rent: 0,
    recommended_market_rent_pk_included: 0,
    price_parking: 0,
    name_parking1: 0,
    cat_parking1: 0,
    name_parking2: 0,
    cat_parking2: 0,
    name_parking3: 0,
    cat_parking3: 0,
    duty_free_fee: 0,
    amount_work: 0,
    surface_land: 0,
    amount_work_no_defisc: 0,
  }
}
